export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILS = "USER_LOGIN_FAILS";

export const USER_LOGOUT = "USER_LOGOUT";

export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAILS = "USER_REGISTER_FAILS";

export const USER_DETAILS_REQUEST = "USER_DETAILS_REQUEST";
export const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS";
export const USER_DETAILS_FAILS = "USER_DETAILS_FAILS";
export const USER_DETAILS_RESET = "USER_DETAILS_RESET";

export const USER_PROFILE_UPDATE_REQUEST = "USER_PROFILE_UPDATE_REQUEST";
export const USER_PROFILE_UPDATE_SUCCESS = "USER_PROFILE_UPDATE_SUCCESS";
export const USER_PROFILE_UPDATE_FAILS = "USER_PROFILE_UPDATE_FAILS";
export const USER_PROFILE_RESET = "USER_PROFILE_RESET";

export const USER_PROFILE_UPDATE_RESET = "USER_PROFILE_UPDATE_RESET";

export const USER_FORGOT_PASS_REQUEST = "USER_FORGOT_PASS_REQUEST";
export const USER_FORGOT_PASS_SUCCESS = "USER_FORGOT_PASS_SUCCESS";
export const USER_FORGOT_PASS_FAILS = "USER_FORGOT_PASS_FAILS";
export const USER_FORGOT_PASS_RESET = "USER_FORGOT_PASS_RESET";

export const USER_RESET_PASS_REQUEST = "USER_RESET_PASS_REQUEST";
export const USER_RESET_PASS_SUCCESS = "USER_RESET_PASS_SUCCESS";
export const USER_RESET_PASS_FAILS = "USER_RESET_PASS_FAILS";
export const USER_RESET_PASS_RESET = "USER_RESET_PASS_RESET";

export const USER_ALL_USERS_REQUEST = "USER_ALL_USERS_REQUEST";
export const USER_ALL_USERS_SUCCESS = "USER_ALL_USERS_SUCCESS";
export const USER_ALL_USERS_FAILS = "USER_ALL_USERS_FAILS";
export const USER_ALL_USERS_RESET = "USER_ALL_USERS_RESET";

export const USER_ORDER_DETAILS_BY_ID_REQUEST =
	"USER_ORDER_DETAILS_BY_ID_REQUEST";
export const USER_ORDER_DETAILS_BY_ID_SUCCESS =
	"USER_ORDER_DETAILS_BY_ID_SUCCESS";
export const USER_ORDER_DETAILS_BY_ID_FAILS = "USER_ORDER_DETAILS_BY_ID_FAILS";
export const USER_ORDER_DETAILS_BY_ID_RESET = "USER_ORDER_DETAILS_BY_ID_RESET";
